/* eslint-disable */
import { auth } from "@/plugins/auth/firebase.js";
import Cookie from "js-cookie";
import JWTDecode from "jwt-decode";
import * as vars from "@/vars.json";
import * as functions from "../payment/functions";
import axios from "axios";

const httpAxios = axios.create({
  timeout: 20000,
  params: {}
});

export const shops = {
  namespaced: true,
  state: {
    shops_list: [],
    favorites_list: [],
    currentItem: null,
    isLoading: false,
    excludedList: [],
    settings: [],
    virtualShops: null,
    current_virtual_shop: null,
    currentStats: null
  },
  mutations: {
    SET_CURRENT_VIRTUAL_SHOP(state, payload) {
      state.current_virtual_shop = payload;
    },
    SET_SHOPS_LIST(state, payload) {
      state.shops_list = payload;
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_CURRENT_ITEM(state, payload) {
      state.currentItem = payload;
    },
    SET_EXCLUDED_PRODUCTS(state, payload) {
      state.excludedList = payload;
    },
    SET_SETTINGS(state, payload) {
      state.settings = payload;
    },
    SET_VIRTUAL_SHOPS(state, payload) {
      state.virtualShops = payload;
    },
    SET_FAVORITES_LIST(state, payload) {
      state.favorites_list = payload;
    },
    SET_STATS: (state, payload) => {
      state.currentStats = payload;
    }
  },

  actions: {
    //AGREGAR UNA QUE SEA SOLO EL DIA ACTUAL
    async loadStats({ commit, state, rootState }) {
      commit("SET_LOADING", true);
      try {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Agregar 1 porque los meses en JS son 0-11
        const day = date
          .getDate()
          .toString()
          .padStart(2, "0");
        const monthKey = `${year}-${month}`;
        let shopId = rootState.shops.currentItem.id;
        let dbRef = firebase
          .database()
          .ref(`users/${userId}/resumeStats/${shopId}/${monthKey}`);
        await dbRef
          .once("value")
          .then(function(snapshot) {
            commit("SET_LOADING", false);
            const stats = snapshot.val();

            // Transformar los datos en el formato deseado
            let formattedStats = [];
            for (let day in stats) {
              if (stats.hasOwnProperty(day)) {
                let dateStats = stats[day];
                formattedStats.push({
                  date: `${monthKey}-${day}`,
                  dailyInvoices: dateStats.dailyInvoices,
                  dailyPurchases: dateStats.dailyPurchases,
                  storePurchaseValue: dateStats.storePurchaseValue,
                  storeValue: dateStats.storeValue,
                  dailyProfit: dateStats.dailyProfit,
                  orders: dateStats.orders
                });
              }
            }
            //console.log(formattedStats, ' FORMATED STATS');
            commit("SET_STATS", formattedStats);
          })
          .catch(function(err) {
            commit("SET_LOADING", false);
            throw err;
          });
      } catch (error) {
        commit("SET_LOADING", false);
        console.log("ERROR", error.message);
        throw error;
      }
    },
    loadItems({ commit, state, rootState, dispatch }, type) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        // console.log(userId)
        let path;
        let loadCommit;

        switch (type) {
          case "shops":
            path = `users/${userId}/shops`;
            loadCommit = "SET_SHOPS_LIST";
            break;
        }

        // console.log(path)
        firebase
          .database()
          .ref(path)
          .orderByChild("name")
          .on(
            "value",
            function(snapshot) {
              const items = [];
              // // console.log('la tiendaaas', Object.values(snapshot.val()))
              snapshot.forEach(function(child) {
                items.push({
                  ...child.val(),
                  id: child.key
                });
              });
              commit(loadCommit, items);
              commit("SET_LOADING", false);
              resolve();
            },
            function(error) {
              console.error(error);
              commit("SET_LOADING", false);
              dispatch("users/showErrorSessionExpired", null, { root: true });
              reject();
            }
          );
      });
    },
    setCurrentItem({ commit, state, rootState }, payload) {
      // console.log(payload)
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }

      if (payload) {
        // console.log(payload)
        let id = payload.id || null;
        return new Promise((resolve, reject) => {
          const path = `users/${userId}/shops`;
          const setCommit = "SET_CURRENT_ITEM";

          const currentItem = state.shops_list.find(
            item => item.id === payload
          );
          if (currentItem) {
            // console.log(currentItem)
            commit(setCommit, currentItem);
            resolve(currentItem);
          } else {
            const dbRef = firebase.database().ref();
            let item;

            dbRef.child(path + "/" + id).on(
              "value",
              function(data) {
                // console.log(data.val(), id)
                item = {
                  ...data.val(),
                  id: data.key
                };
                // console.log(item)
                commit(setCommit, item);
                // commit('setLoading', false);
                resolve(item);
              },
              function(error) {
                // console.log(error)
                // commit('setLoading', false);
                reject();
              }
            );
          }
        });
      } else {
        commit("SET_CURRENT_ITEM", null);
      }
    },
    loadTopSales({ commit, state, rootState }, payload) {
      // console.log(payload)
    },
    deleteItem({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        const id = payload.id;
        commit("SET_LOADING", true);
        const promises = [];
        // console.log(`shops/pictures/${id}`)
        promises.push(
          firebase
            .database()
            .ref()
            .child(`users/${userId}/shops/${id}`)
            .remove()
        );
        promises.push(
          firebase
            .database()
            .ref()
            .child(`virtualshop/${id}`)
            .remove()
        );
        if (payload.pictures.imageInput1) {
          promises.push(
            firebase
              .storage()
              .ref(`users/${userId}/shops/pictures/${id}`)
              .child("imageInput1")
              .delete()
          );
        }
        Promise.all(promises).then(
          function() {
            // commit('setWriting', false);
            commit("SET_CURRENT_ITEM", null);
            commit("SET_LOADING", false);
            resolve();
          },
          function(error) {
            commit("SET_LOADING", false);
            // console.log(error)
            reject();
          }
        );
      });
    },
    createItem({ commit, state, rootState }, payload) {
      return new Promise(async (resolve, reject) => {
        // commit('SET_LOADING', true)
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        // console.log(state.user, userId)
        const key = payload.id
          ? payload.id
          : firebase
              .database()
              .ref()
              .child(`users/${userId}/shops`)
              .push().key;
        const itemData = {
          ...payload,
          id: key,
          ownerId: userId,
          created: firebase.database.ServerValue.TIMESTAMP
        };
        const updates = {};
        updates[`users/${userId}/shops/${key}`] = itemData;
        await firebase
          .database()
          .ref()
          .update(updates)
          .then(function() {
            commit("SET_CURRENT_ITEM", itemData);
            // commit('SET_LOADING', false)
            resolve(key);
          })
          .catch(function(err) {
            reject(err);
            commit("SET_LOADING", false);
            throw err;
          });
      });
    },
    async updateItem({ commit, state, rootState }, payload) {
      commit("SET_LOADING", true);
      const vm = this;

      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      const itemData = payload;
      await firebase
        .database()
        .ref(`users/${userId}/shops/${itemData.id}`)
        .update(itemData)
        .then(function() {
          // updated!
          commit("SET_LOADING", false);
        })
        .catch(function(err) {
          commit("SET_LOADING", false);
          throw err;
        });
    },
    excludedProducts({ rootState, commit }, payload) {
      let excludedList = [];
      let userId = rootState.users.user.adminUid
        ? rootState.users.user.adminUid
        : rootState.users.user.uid;
      let shopId = rootState.shops.currentItem.id;
      let ref = firebase
        .database()
        .ref()
        .child(`users/${userId}/shops/${shopId}`);
      payload.forEach(product => {
        excludedList[product.id] = {
          id: product.id,
          name: product.name,
          image: product.pictures.imageInput1
        };
      });
      commit("SET_EXCLUDED_PRODUCTS", excludedList);
      // update firebase
      ref.once("value", function(snapshot) {
        ref.update({
          excluded: {
            ...excludedList
          }
        });
      });
    },
    async loadExcludedProducts({ rootState, commit }) {
      let userId = rootState.users.user.adminUid
        ? rootState.users.user.adminUid
        : rootState.users.user.uid;
      let shopId = rootState.shops.currentItem.id;
      let ref = firebase
        .database()
        .ref()
        .child(`users/${userId}/shops/${shopId}/excluded`);
      let excluded = [];
      await ref.on("value", function(snapshot) {
        const items = snapshot.val() || {};
        excluded = Object.values(items);
        // console.log(excluded)
        commit("SET_EXCLUDED_PRODUCTS", excluded);
      });
      return excluded;
    },
    async deleteExcludedItem({ commit, state, rootState, dispatch }, payload) {
      let userId = rootState.users.user.adminUid
        ? rootState.users.user.adminUid
        : rootState.users.user.uid;
      let shopId = rootState.shops.currentItem.id;
      // delete firebase
      firebase
        .database()
        .ref()
        .child(`users/${userId}/shops/${shopId}/excluded/${payload}`)
        .remove();
      const newExcludedList = state.excludedList.filter(products => {
        return products.id !== payload;
      });
      commit("SET_EXCLUDED_PRODUCTS", newExcludedList);
    },
    settingUpCurrentShop({ commit, state, rootState }, payload) {
      let userId = rootState.users.user.adminUid
        ? rootState.users.user.adminUid
        : rootState.users.user.uid;
      let shopId = rootState.shops.currentItem.id;
      let ref = firebase
        .database()
        .ref()
        .child(`users/${userId}/shops/${shopId}/`);
      ref.once("value", function(snapshot) {
        ref.update({
          settings: {
            ...payload
          }
        });
      });
    },
    async loadSettings({ rootState, commit }) {
      let userId = rootState.users.user.adminUid
        ? rootState.users.user.adminUid
        : rootState.users.user.uid;
      let shopId = rootState.shops.currentItem.id;
      let ref = firebase
        .database()
        .ref()
        .child(`users/${userId}/shops/${shopId}/settings`);
      await ref.on("value", function(snapshot) {
        commit("SET_SETTINGS", Object.values(snapshot.val()));
        console.info(
          "configuracion de firebase",
          Object.values(snapshot.val())
        );
      });
    },
    getVitualShop({ state, rootState }, uidShop) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`virtualshop/${uidShop}/`)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = [];
              if (res) {
                arr = Object.keys(res).map(item => {
                  return { id: item, data: res[item] };
                });
              }
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getVitualShopUser({ state, rootState }, uidShop) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`virtualshop/`)
          .orderByChild("dataShop/uid")
          .equalTo(rootState.users.user.uid)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = [];
              if (res) {
                arr = Object.keys(res).map(item => {
                  return { id: item, data: res[item] };
                });
              }
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    deleteVirtualShop({ state, rootState }, idShop) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`virtualshop/${idShop}/`)
          .remove()
          .then(res => {
            // commit('SET_LOADING', false)
            resolve(true);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    createVirtualShop({ state, rootState }, dataShop) {
      return new Promise((resolve, reject) => {
        dataShop.uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`virtualshop/${dataShop.id}/`)
          .update({
            dataShop
          })
          .then(res => {
            // commit('SET_LOADING', false)
            resolve(true);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    saveVirtualShopImage({ state, rootState }, dataShop) {
      return new Promise((resolve, reject) => {
        dataShop.uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`virtualshop/${dataShop.id}/dataShop/img/`)
          .update(dataShop.img)
          .then(res => {
            // commit('SET_LOADING', false)
            resolve(true);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    validSubdomain({ state, rootState }, subdomain) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/validSubdomain", { subdomain: subdomain })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getVirtualShopList({ state, rootState }) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`virtualshop`)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = Object.keys(res).map(item => {
                return { id: item, data: res[item] };
              });
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getUserInventory({ state, rootState }, dataSend) {
      return new Promise((resolve, reject) => {
        const data = functions.encrypt(dataSend);
        httpAxios
          .post(vars.url + "/getUserInventory", data)
          .then(response => {
            response.data = functions.decrypt(response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUserCategories({ state, rootState }, dataSend) {
      return new Promise((resolve, reject) => {
        const data = functions.encrypt(dataSend);
        httpAxios
          .post(vars.url + "/getUserCategories", data)
          .then(response => {
            response.data = functions.decrypt(response.data);
            resolve(response);
          })
          .catch(error => {
            router.push(rejectPage);
            reject(error);
          });
      });
    },
    getMainCategories({ state, rootState }, idioma) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`main-categories`)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = Object.keys(res[idioma]).map(cat => {
                return { id: cat, data: res[idioma][cat] };
              });
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getVirtualShopData({ state, rootState }, data) {
      return new Promise((resolve, reject) => {
        data = functions.encrypt(data);
        httpAxios
          .post(vars.url + "/getVirtualShops", data)
          .then(response => {
            response.data = functions.decrypt(response.data);
            resolve(response);
          })
          .catch(error => {
            router.push(rejectPage);
            reject(error);
          });
      });
    },
    async getVirtualShopUserList({ commit, rootState }) {
      firebase
        .database()
        .ref(`virtualshop`)
        .orderByChild("dataShop/uid")
        .equalTo(rootState.users.user.uid)
        .on(
          "value",
          snapshot => {
            const res = snapshot.val();
            if (res) {
              let arr = Object.keys(res).map(vs => {
                return { id: vs, data: res[vs] };
              });
              commit("SET_VIRTUAL_SHOPS", arr);
            } else {
              commit("SET_VIRTUAL_SHOPS", []);
            }
          },
          error => {
            commit("SET_VIRTUAL_SHOPS", []);
          }
        );
    },
    getVirtualShop({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        let shopId = payload.subdomain;
        firebase
          .database()
          .ref(`virtualshop`)
          .orderByChild("dataShop/subdomain")
          .equalTo(shopId)
          .on(
            "value",
            snapshot => {
              if (snapshot.val()) {
                const res = Object.values(snapshot.val())[0].dataShop;
                commit("SET_CURRENT_VIRTUAL_SHOP", res);
                resolve(res);
              } else {
                commit("SET_CURRENT_VIRTUAL_SHOP", {});
                resolve({});
              }
            },
            error => {
              commit("SET_CURRENT_VIRTUAL_SHOP", {});
              reject(error);
            }
          );
      });
    },
    loadFavorites({ commit, state, rootState }) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        // console.log(userId)
        const path = `users/${userId}/favorites`;
        const loadCommit = "SET_FAVORITES_LIST";

        firebase
          .database()
          .ref(path)
          .orderByChild("name")
          .on(
            "value",
            function(snapshot) {
              // console.log(snapshot.val())
              const items = [];
              snapshot.forEach(function(child) {
                items.push({
                  ...child.val(),
                  id: child.key
                });
              });
              commit(loadCommit, items);
              resolve();
            },
            function(error) {
              console.error(error);
              reject();
            }
          );
      });
    },
    addToFavorites({ commit, rootState }, payload) {
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      const shopData = {
        id: payload.id,
        name: payload.name,
        description: payload.description,
        image: payload.img.imageInput1,
        address: payload.address,
        addressgoogle: payload.addressgoogle
      };
      try {
        firebase
          .database()
          .ref(`users/${userId}/favorites/${payload.id}`)
          .update(shopData)
          .then(function() {
            // console.log('ok')
          })
          .catch(function(err) {
            throw err;
          });
      } catch (error) {
        throw error;
      }
    },
    removeFavorites({ commit, rootState }, payload) {
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      try {
        firebase
          .database()
          .ref(`users/${userId}/favorites/${payload.id}`)
          .remove()
          .then(function() {
            // console.log('ok')
          })
          .catch(function(err) {
            throw err;
          });
      } catch (error) {
        throw error;
      }
    },
    saveImage({ rootState }, imageInfo) {
      const shopId = rootState.shops.currentItem.id;
      const userId = rootState.users.user.uid;
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/saveShopImage", {
            uid: userId,
            image: imageInfo.whichOne,
            url: imageInfo.url,
            shopId: shopId
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    loadShopsByUser({ commit, state, rootState }, userId) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${userId}/shops`)
          .orderByChild("name")
          .on(
            "value",
            function(snapshot) {
              const items = [];
              snapshot.forEach(function(child) {
                items.push({
                  ...child.val(),
                  id: child.key
                });
              });
              commit("SET_SHOPS_LIST", items);
              resolve(items);
            },
            function(error) {
              console.error(error);
              commit("SET_LOADING", false);
              reject();
            }
          );
      });
    }
  },
  getters: {
    getCurrentStats(state) {
      return state.currentStats;
    },
    getTotalMonthlyStats: state => {
      return state.currentStats.reduce(
        (total, dayStat) => {
          total.dailyInvoices += dayStat.dailyInvoices || 0;
          total.dailyPurchases += dayStat.dailyPurchases || 0 ;
          total.storePurchaseValue += dayStat.storePurchaseValue || 0;
          total.storeValue += dayStat.storeValue || 0;
          total.dailyProfit += dayStat.dailyProfit || 0;
          total.orders += dayStat.orders || 0;
          return total;
        },
        {
          dailyInvoices: 0,
          dailyPurchases: 0,
          storePurchaseValue: 0,
          storeValue: 0,
          dailyProfit: 0,
          orders: 0
        }
      );
    },
    getCurrentShop(state) {
      return state.current_virtual_shop;
    },
    getEx(state) {
      return state.excludedList;
    },
    getItems(state) {
      return state.shops_list;
    },
    getCurrentItem(state) {
      return state.currentItem;
    },
    getFavorites(state) {
      return state.favorites_list;
    },
    getLoading(state) {
      return state.isLoading;
    }
    // getExcludedProducts(state) {
    //     console.info(`productos excluidos: ${state.excludedList.length}`)
    //     return state.excludedList
    // }
  }
};
